import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import getAppConfig from '../api/CustomHRD/getAppConfig';
import { setAppConfig } from '../constants/appConfig';

const ConfigLoader = ({ children }) => {
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    getAppConfig()
      .then((config) => {
        setAppConfig(config);
        setReady(true);
      })
      .catch(() => setError(true));
  }, []);

  if (error) return null;
  if (!ready) return null;

  return children;
};

ConfigLoader.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ConfigLoader;
